export default __webpack_public_path__ + "images/4781ed9dd6af985150e55dbe0bd89278.jpg";